import { Loading } from './Loading'

export function FullScreenLoading() {
  return (
    <div className="grid min-h-screen place-items-center bg-basic-bg">
      <Loading />
    </div>
  )
}
